import { ExpandMoreRoundedIcon, IconButton, Rotate, Text } from '@shared/components';

export interface AccordionEndAdornmentProps {
  label?: string;
  expanded?: boolean;
  onExpandToggle?: () => void;
}

export default function AccordionEndAdornment(props: Readonly<AccordionEndAdornmentProps>) {
  const { label, expanded: isExpanded = false, onExpandToggle } = props;

  return (
    <>
      <Text variant='body2' color='text.secondary'>
        {label}
      </Text>
      <IconButton onClick={onExpandToggle}>
        <Rotate in={isExpanded}>
          <ExpandMoreRoundedIcon sx={{ color: (theme) => theme.palette.grey[600] }} />
        </Rotate>
      </IconButton>
    </>
  );
}
